import { render, staticRenderFns } from "./DeviceLayoutXuefengshan.vue?vue&type=template&id=6c895735&scoped=true"
import script from "./DeviceLayoutXuefengshan.vue?vue&type=script&lang=js"
export * from "./DeviceLayoutXuefengshan.vue?vue&type=script&lang=js"
import style0 from "./DeviceLayoutXuefengshan.vue?vue&type=style&index=0&id=6c895735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c895735",
  null
  
)

export default component.exports